import { SubmissionError } from 'redux-form';
export default SubmissionError;